import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const employeeTransactionApproverService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/EmployeeTransactionApprover`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/EmployeeTransactionApprover`, payload, { headers });
  },

  // ADDED: Update method
  update: async (id, payload) => {
    return await axios.put(`${domain}/api/EmployeeTransactionApprover/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/EmployeeTransactionApprover/${id}`, { headers });
  },
};

export default employeeTransactionApproverService;